import { Icon, IconName } from './Icon';
import { FC, ReactElement } from 'react';
import { ElementsButton } from './Button';

interface ErrorBannerProps {
  errorText: string;
  actionButton?: ReactElement<typeof ElementsButton>;
  icon?: IconName;
  className?: string;
}

export const ErrorBanner: FC<ErrorBannerProps> = ({ errorText, actionButton, icon = 'warning' }) => {
  return (
    <div className={'flex items-center bg-darkMode-danger/10 justify-between px-4 py-2 -mx-6 sm:-mx-12'}>
      <div className={'flex gap-4'}>
        <Icon icon={icon} className={'text-darkMode-danger'} />
        <p className="text-darkMode-danger">{errorText}</p>
      </div>
      {actionButton}
    </div>
  );
};
